(function($) {
    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    jQuery(document).ready(function($) {
        // Current packages
        var projectGallery = new Swiper('.gallery-image', {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 8,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
        });

        // Startslider frontpage
        var startPage = new Swiper('.projects-startslider', {
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },
            scrollbar: {
                el: '.swiper-scrollbar'
            },
        });

        // Single project more project slider (Mobile only)
        if (windowWidth < 767) {
            var swiper1 = new Swiper('.more-projects .swiper-container', {
                slidesOffsetBefore: -30,
                slidesPerView: 'auto',
                centeredSlides: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                breakpoints: {
                    320: {
                        slidesOffsetBefore: 15,
                    },
                    375: {
                        slidesOffsetBefore: -10,
                    }
                }
            });
        }

        // More news slider
        // Mobile
        if (windowWidth < 767) {
            var swipernews = new Swiper('.more-news', {
                slidesOffsetBefore: -35,
                slidesPerView: 'auto',
                centeredSlides: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                breakpoints: {
                    320: {
                        slidesOffsetBefore: 8,
                    },
                    375: {
                        slidesOffsetBefore: -18,
                    }
                }
            });
        }
        


        // Quotes slider
        var quoteGallery = new Swiper('.quotes', {
            slidesPerView: 3,
            slidesPerGroup: 2,
            slidesOffsetBefore: -250,
            centeredSlides: true,
            scrollbar: {
                el: '.swiper-scrollbar',
            },


            breakpoints: {
                // when window width is >= 320px

                480: {
                    slidesPerGroup: 1,
                    spaceBetween: 30,
                    slidesOffsetBefore: -30,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                },
                // when window width is >= 640px
                720: {
                    slidesPerGroup: 1,
                    spaceBetween: 40,
                    slidesOffsetBefore: -30,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                },

                1367: {
                    slidesPerView: 2.5,
                    slidesOffsetBefore: 0,
                    centeredSlides: false,
                },


                1540: {
                    slidesOffsetBefore: -400,
                },

                1900: {
                    slidesOffsetBefore: -400,
                    slidesPerView: 3.5,
                },

                2050: {
                    slidesOffsetBefore: -300,
                },

                2200: {
                    slidesOffsetBefore: -230,
                    slidesPerView: 2.7,
                }



            }
        });
    });

})(jQuery);
